<template>
  <div class="broker-real-estate-development-view">
    <v-row>
      <v-col md="12">
        <real-estate-development-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

export default {
  components: {
    RealEstateDevelopmentTable: () =>
      import(
        "@/components/real-estate-development/RealEstateDevelopmentList.vue"
      )
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
